<template>
  <CCol>
    <CRow>
      <CCol sm="12">
        <CRow class="justify-content-between align-items-start">
          <CCol v-if="messages.length">
            <transition name="fade">
              <MenssageAlert :messages="messages" />
            </transition>
          </CCol>

          <CCol v-else v-for="target in targets" :key="target.id" sm="6" class="p-0 text-gray-600 cardChannel">
            <CInputRadio
              type="radio"
              :id="target.name"
              :value="target.name"
              name="target"
              :checked="targetSMSContent == target.name"
              @update:checked="(b) => check(b, target.name)"
              class="cardChannel__checkRadio"
              :class="{
                'cardChannel__checkRadio--active': targetSMSContent == target.name,
              }"
              hidden
            />

            <div class="cardChannel__child m-1">
              <label :for="target.name" class="d-flex justify-content-center align-items-center flex-column p-3">
                <CIcon :name="target.name" :height="32" viewBox="0 0 32 32" />
                <span class="font-weight-normal font-md text-center">
                  {{ $t(`sidebar.blocksLibrary.campaign.component.content.options.label.${target.name}`) }}
                </span>
              </label>
            </div>
          </CCol>

          <CCol sm="12">
            <transition name="fade">
              <div>
                <label for="sender" class="mt-3">{{ $t(`sidebar.blocksLibrary.campaign.component.content.options.label.sender`) }} </label>
                <multiselect
                  v-model="sender"
                  :multiple="false"
                  :options="senderList"
                  custom
                  :custom-label="(option) => option.label"
                  :allow-empty="false"
                  :show-labels="false"
                  class="multiselect--custom"
                  :placeholder="$t(`sidebar.blocksLibrary.campaign.component.content.options.label.select-one`)"
                  @input="saveContent()"
                >
                  <template slot="singleLabel" slot-scope="props">
                    {{ sender ? sender.label : $t(`sidebar.blocksLibrary.campaign.component.content.options.label.select-one`) }}
                  </template>
                  <template slot="option" slot-scope="props">
                    <CRow>
                      <CCol>{{ props.option.label }} </CCol>
                      <CCol class="text-right" v-if="props.option.route">
                        <CButton class="px-3 py-1" color="primary">
                          {{ $t(`sidebar.blocksLibrary.campaign.component.content.options.button.new`) }}
                        </CButton>
                      </CCol>
                    </CRow>
                  </template>
                </multiselect>
              </div>
            </transition>
          </CCol>

          <CCol sm="12" v-if="targetSMSContent == 'newSms'">
            <transition name="fade">
              <div>
                <label for="CustomFields" class="mt-3">
                  {{ $t(`sidebar.blocksLibrary.campaign.component.content.options.label.custom-fields`) }}
                  <span class="text-gray-500"> ({{ $t(`sidebar.blocksLibrary.campaign.component.content.options.label.optional`) }}) </span></label
                >
                <CRow :gutters="false" class="d-flex align-items-center">
                  <CCol sm="12">
                    <multiselect
                      v-model="selectedCustomField"
                      :multiple="false"
                      :options="customFieldsList"
                      :customLabel="customLabel"
                      ref="textAreaCustom"
                      class="multiselect--custom"
                      :allow-empty="false"
                      :show-labels="false"
                      :placeholder="$t(`sidebar.blocksLibrary.campaign.component.content.options.label.select-one`)"
                    >
                    </multiselect>
                  </CCol>
                  <CCol sm="12" class="mt-2">
                    <CButton
                      :disabled="!selectedCustomField"
                      type="button"
                      class="btn btn-primary py-2 text-uppercase w-100"
                      @click="addCustomField()"
                    >
                      {{ $t(`sidebar.blocksLibrary.campaign.component.content.options.button.add`) }}
                    </CButton>
                  </CCol>
                </CRow>
              </div>
            </transition>
          </CCol>

          <CCol sm="12" v-if="targetSMSContent == 'newSms'">
            <transition name="fade">
              <div>
                <label for="CustomFields" class="mt-3">
                  {{ $t(`sidebar.blocksLibrary.campaign.component.content.sms-quantity.text.message`) }}
                </label>
                <SMSTemplateTextarea
                  :loaded-message-text="smsMessage"
                  :added-custom-field="addedCustomField"
                  @message-changed="handleSMSMessageChanged"
                  class="font-sm"
                />
                <div v-if="hasCustomField">
                  <p class="text-gray-600 font-12 justify mt-3" style="text-align: justify">
                    {{ $t(`sidebar.blocksLibrary.campaign.component.content.sms-quantity.text.description`) }}
                  </p>
                </div>
              </div>
            </transition>
          </CCol>

          <CCol sm="12" v-if="targetSMSContent == 'smsTemplate'">
            <transition name="fade">
              <div>
                <label for="template" class="mt-3">
                  {{ $t(`sidebar.blocksLibrary.campaign.component.content.options.label.template`) }}
                </label>
                <multiselect
                  v-model="template"
                  :multiple="false"
                  :options="templateList"
                  :custom-label="(option) => option.label"
                  custom
                  class="multiselect--custom"
                  :allow-empty="false"
                  :show-labels="false"
                  :placeholder="$t(`sidebar.blocksLibrary.campaign.component.content.options.label.select-one`)"
                  @input="changeTemplate()"
                >
                </multiselect>
              </div>
            </transition>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </CCol>
</template>

<script>
import services from '@/services.js'
import SMSTemplateTextarea from '@/components/SMSTemplateTextarea.vue'
const CUSTOM_GROUP = 'CUSTOM'

export default {
  name: 'SmsContent',
  components: { SMSTemplateTextarea },
  props: {
    indice: {
      type: Number,
      default: null,
    },
    content: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      segments: [],
      override: [],
      options: [],
      targetSMSContent: null,
      targets: [
        { name: 'newSms', title: 'New' },
        { name: 'smsTemplate', title: 'Template' },
      ],
      smsMessage: '',
      senderList: [], //["Sender 1", "Sender 2"],
      sender: {},
      addedCustomField: undefined,
      selectedCustomField: null,
      customFieldsList: [], // ["First name", "Last name", "Country", "Birthday"],
      template: {},
      templateList: [], //["Template 1", "Template 2", "Template 3"],
      messages: [],
      currentOption: null,
      isNewContent: null,
      message: '',
    }
  },
  methods: {
    changeTemplate() {
      this.smsMessage = this.template.templateContent
      this.saveContent()
    },

    check(value, name) {
      if (value) {
        this.targetSMSContent = name
        this.isNewContent = name === 'newSms'

        // Caso clique em uma opção diferente, reinicia os valores dos campoos
        if (this.currentOption !== name) {
          this.smsMessage = ''
          this.sender = {}
          this.template = {}
          this.selectedCustomField = null
          this.saveContent()
        }

        this.currentOption = name
      }
    },

    addCustomField() {
      if (!this.selectedCustomField) return

      this.addedCustomField = this.selectedCustomField
      this.selectedCustomField = null

      setTimeout(() => {
        this.addedCustomField = null
      }, 100)
    },

    handleSMSMessageChanged(msgValue) {
      this.smsMessage = msgValue
      this.saveContent()
    },

    customLabel(option) {
      return `${option.value}`
    },

    async getSchema() {
      try {
        const FIELD_TYPES = await services.fieldtypes(this.$store.state.auth.organizationId)

        const SCHEME = await services.audienceSchema(this.$store.state.auth.organizationId)

        if (SCHEME.data.data.errorCode === 1000) {
          this.customFieldsList = [...this.handleCustomtypes(FIELD_TYPES)]
          throw 'AUDIENCE_SCHEMA_NOT_FOUND'
        }

        this.customFieldsList = [...SCHEME.data.data.values, ...this.handleCustomtypes(FIELD_TYPES)]
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.Message || 'ERROR',
        })
      }
    },

    handleCustomtypes(FIELD_TYPES) {
      let CUSTOMS = FIELD_TYPES.data.data.groups.filter((group) => group.group == CUSTOM_GROUP)

      if (CUSTOMS[0].types.lenght) {
        return CUSTOMS.map((item, index) => {
          return {
            ...item.types[index],
            value: item.types[index].personalizationTag,
          }
        })
      }

      return []
    },

    getSenders() {
      // Caso já tenha carregado uma vez, não precisa realizar novamente o request
      // TODO Isso estava impedindo que novos senders aprovados fossem listados.
      /*if (this.$store.state.campaign.auxiliares.senders != null) {
        // Verifica se é um array válido
        if (Array.isArray(this.$store.state.campaign.auxiliares.senders)) {
          // Se o array não tiver itens, vai buscar novamente
          if (this.$store.state.campaign.auxiliares.senders.length > 0) {
            this.senderList = [...this.$store.state.campaign.auxiliares.senders]
            return
          }
        }
      }*/
      let organizationId = this.$route.params.organizationId

      services.getSendersByOrganizationUserId(organizationId).then((res) => {
        let list = res.data.data.map((elm) => {
          return { value: elm.senderId, label: elm.sender }
        })
        if (list?.length > 0) {
          this.senderList = list
        } else {
          this.sender = null
          this.senderList = [
            {
              label: this.$t(`sidebar.blocksLibrary.campaign.component.content.options.label.emptyList`),
              value: 'new',
              route: { name: 'new-senders-sms' },
            },
          ]
        }

        this.$store.commit('campaign/UPDATE_AUXILIARES', {
          senders: [...this.senderList],
        })
      })
    },

    getTemplates() {
      // Caso já tenha carregado uma vez, não precisa realizar novamente o request
      /*if (this.$store.state.campaign.auxiliares.templates) {
        // Verifica se é um array válido
        if (Array.isArray(this.$store.state.campaign.auxiliares.templates)) {
          // Se o array não tiver itens, vai buscar novamente
          if (this.$store.state.campaign.auxiliares.templates.length > 0) {
            this.templateList = [
              ...this.$store.state.campaign.auxiliares.templates
            ]
            return
          }
        }
      }*/
      let organizationId = this.$store.state.auth.organizationId

      services.getTemplateSMSOrganization(organizationId).then((res) => {
        let list = res.data.data.templates.map((elm) => {
          return {
            value: elm.smsTemplateId,
            label: elm.name,
            templateContent: elm.templateContent,
          }
        })
        this.templateList = list
        this.$store.commit('campaign/UPDATE_AUXILIARES', {
          templates: [...this.templateList],
        })
      })
    },

    saveContent() {
      if (this.sender?.route != null) {
        this.$router.push({ name: this.sender.route.name })
        return
      }

      let model = {
        indice: this.indice,
        content: {
          targetSMSContent: this.targetSMSContent,
          templateId: this.template.value ?? null,
          content: this.smsMessage,
          senderId: this.sender?.value ?? null,
          senderName: this.sender?.label ?? null,
          isNewContent: this.isNewContent,
        },
      }

      this.$store.dispatch('campaign/setSmsContent', JSON.parse(JSON.stringify(model)))
    },

    loadContent() {
      if (this.indice !== null) {
        this.selectedCustomField = null
        // Seleciona a opção dos radios. Isto deve ser feito antes, pois a alteração e valores deste input alteram os dados resultante
        if (this.content.isNewContent != null) this.targetSMSContent = this.content.isNewContent ? 'newSms' : 'smsTemplate'
        else this.targetSMSContent = null

        // Por conta do objeto this.content fazer referência a um objeto que está no state do Vuex, se faz necessário copia-lo para que não haja passagem por referência
        let obj = JSON.parse(JSON.stringify(this.content))
        this.template.value = obj.templateId ? obj.templateId : null
        this.smsMessage = obj.content ? obj.content : ''
        this.sender.value = obj.senderId ? obj.senderId : null
        this.sender.label = obj.senderName ? obj.senderName : null
        this.isNewContent = obj.isNewContent ? obj.isNewContent : null
      }
    },
  },
  computed: {
    hasCustomField: function () {
      if (this.customFieldsList.length > 0) {
        for (var i = 0; i < this.customFieldsList.length; i++) {
          if (this.smsMessage.indexOf(`[${this.customFieldsList[i].personalizationTag}]`) > -1) {
            return true
          }
        }
      }
      return false
    },
  },
  watch: {
    indice: function () {
      this.loadContent()
      this.getSenders()
    },
  },
  mounted() {
    this.getSchema()
    this.getSenders()
    this.getTemplates()
    this.loadContent()
  },
}
</script>

<style scoped lang="scss">
.select-with-border {
  border: 1px solid #e5e5e5;
}
.font-12 {
  font-size: 12px;
}
.font-9 {
  font-size: 9px;
}
</style>
